/**
 * Role filtering groups
 */
import { SUPPORT_GROUP } from "./roleConfig";

const navigationLinks = [
  {
    to: "/customers",
    icon: "fa fa-user-o",
    text: "Customers",
    subroles: [],
  },
  {
    to: "/appointments",
    icon: "fa fa-address-card",
    text: "Appointments",
    subroles: [],
  },
  {
    to: "/organizations",
    icon: "fa fa-globe",
    text: "Organizations",
    subroles: [],
  },
  {
    to: "#",
    icon: "fa fa-laptop",
    text: "FULFILLMENT",
    subroles: SUPPORT_GROUP,
    items: [
      {
        to: "/fulfillment/asns",
        text: "Advance Shipping Notice",
        subroles: SUPPORT_GROUP,
      },
      {
        to: "/fulfillment/orders",
        text: "Orders",
        subroles: SUPPORT_GROUP,
      },
      {
        to: "/fulfillment/shipments",
        text: "Shipments",
        subroles: SUPPORT_GROUP,
      },
    ],
  },
];

export { navigationLinks };
